module.exports = __webpack_public_path__ + "static/img/info_top.3ed9824.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_top.png
// module id = mbg2
// module chunks = 1